<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHeadset_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12 3c5.523 0 10 4.477 10 10v3.5a3.5 3.5 0 0 1-3.5 3.5c-1.933 0-2.5-1.567-2.5-3.5v-2c0-1.933.567-3.5 2.5-3.5.463 0 .904.09 1.309.253a8.003 8.003 0 0 0-15.618 0A3.5 3.5 0 0 1 5.5 11C7.433 11 8 12.567 8 14.5v2c0 1.933-.567 3.5-2.5 3.5A3.5 3.5 0 0 1 2 16.5V13C2 7.477 6.477 3 12 3"
    />
</svg>
